














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ITabItem } from './index';

@Component
export default class extends Vue {
  @Prop({
    type: Array,
    default: []
  })
  private tabs!: ITabItem[];

  @Prop({ default: 0 })
  private current!: number;

  @Watch('current', { immediate: true })
  currentChange(n: number) {
    this.act = n;
  }

  private act: number = 0;

  itemClick(item: ITabItem, index: number) {
    this.act = index;
    this.$emit('change', item.value);
    this.$emit('update:current', this.act);
  }
}
